import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import DangerousRounded from "@mui/icons-material/DangerousRounded";
import Dataset from "@mui/icons-material/Dataset";
import Description from "@mui/icons-material/Description";
import Folder from "@mui/icons-material/Folder";
import GroupAddRounded from "@mui/icons-material/GroupAddRounded";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { blue, green, grey, lightGreen, red, yellow } from "@mui/material/colors";
import {
	AccountTree,
	AddRounded,
	AddToPhotos,
	Archive,
	AutoAwesomeMotion,
	Camera,
	CancelOutlined,
	CurrencyRupee,
	CurrencyRupeeRounded,
	DatasetRounded,
	DeleteRounded,
	DesignServices,
	DocumentScanner,
	DownloadRounded,
	DryCleaning,
	Edit,
	Inventory,
	LibraryAdd,
	LocalMall,
	NoteAddRounded,
	Pending,
	RecentActors,
	Source,
	UploadFile,
} from "@mui/icons-material";

import InfoIcon from "@mui/icons-material/Info";
import StyleIcon from "@mui/icons-material/Style";

import moment from "moment";
import { Box, fabClasses, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import styled from "@emotion/styled";
import axios from "axios";
import { useGridApiContext } from "@mui/x-data-grid";
export const objType = "obj";
export const arrType = "arr";
export const selectOptionsKeyName = "options";
export const uploadImageFileTypes = ["jpg", "jpeg", "png", "webp"];
export const uploadImageMimeTypes = ["image/jpeg", "image/png", "image/webp"];

export const PimDashboardServices = {
	designer: {
		name: "DESIGNER",
		key: "designer",
		display: true,
		icon: <DesignServices />,
		types: {
			attribute_master: {
				name: "Attribute Master",
				key: "attribute_master",
				display: true,
				icon: <Dataset />,
				types: {
					attributes: {
						name: "Attributes",
						key: "attributes",
						display: true,
						icon: <Description />,
					},
					attribute_groups: {
						name: "Attribute Groups",
						key: "attribute_groups",
						display: true,
						icon: <Description />,
					},
				},
			},
			create_style: {
				name: "Create Style",
				key: "create_style",
				display: true,
				icon: <LibraryAdd />,
			},
			bulk_upload_styles: {
				name: "Bulk Upload Styles",
				key: "bulk_upload_styles",
				display: true,
				icon: <UploadFile />,
			},
			styles: {
				name: "Styles",
				key: "styles",
				display: true,
				icon: <AutoAwesomeMotion />,
			},
			selected_style: {
				name: "Selected Style",
				key: "selected_style",
				icon: <AutoAwesomeMotion />,
				display: false,
			},
			// designer_users: {
			// 	name: "Users",
			// 	key: "designer_users",
			// 	icon: <AutoAwesomeMotion />,
			// 	display: true,
			// },
			fabric_trims_sheet: {
				name: "Fabric & Trims",
				key: "fabric_trims_sheet",
				display: true,
				icon: <DryCleaning />,
			},
		},
	},
	buying: {
		name: "BUYING",
		key: "buying",
		display: true,
		icon: <LocalMall />,
		types: {
			mrp_sheet: {
				name: "MRP Sheet",
				key: "mrp_sheet",
				display: true,
				icon: <CurrencyRupee />,
			},
			buy_qty_sheet: {
				name: "Buy Qty Sheet",
				key: "buy_qty_sheet",
				display: true,
				icon: <Inventory />,
			},
			buying_sheet: {
				name: "Buying Sheet",
				key: "buying_sheet",
				display: false,
				icon: <Inventory />,
			},
			selected_buying: {
				name: "Selected Buying",
				key: "selected_buying",
				icon: <AutoAwesomeMotion />,
				display: false,
			},
		},
	},
	sourcing: {
		name: "SOURCING",
		key: "sourcing",
		display: true,
		icon: <NoteAddRounded />,
		types: {
			fabric_styles: {
				name: "Style Sheet",
				key: "fabric_styles",
				display: true,
				icon: <Dataset />,
			},
			fabric_master: {
				name: "Fabric Master",
				key: "fabric_master",
				display: true,
				icon: <DryCleaning />,
			},
			trims: {
				name: "Trims",
				key: "trims",
				display: true,
				icon: <StyleIcon />,
				types: {
					trims_master: {
						name: "Trims Master",
						key: "trims_master",
						display: true,
						icon: <StyleIcon />,
					},
					zipper_puller_master: {
						name: "Zipper-Puller Master",
						key: "zipper_puller_master",
						display: true,
						icon: <StyleIcon />,
					},
					thread_master: {
						name: "Thread Master",
						key: "thread_master",
						display: true,
						icon: <StyleIcon />,
					},
				},
			},
			trims_erp: {
				name: "Trims ERP",
				key: "trims_erp",
				display: false,
				icon: <StyleIcon />,
			},
			footwear_material_master: {
				name: "Footwear Material Master",
				key: "footwear_material_master",
				display: true,
				icon: <DryCleaning />,
			},
			merchant_data: {
				name: "Studio Sample Details",
				key: "merchant_data",
				display: true,
				icon: <Dataset />,
			},
			fob_po: {
				name: "FOB  PO",
				key: "fob_po",
				display: true,
				icon: <DocumentScanner />,
			},
			open_costing: {
				name: "Open Costing",
				key: "open_costing",
				display: true,
				icon: <CurrencyRupee />,
				types: {
					create_open_costing: {
						name: "Create Costing",
						key: "create_open_costing",
						display: true,
						icon: <AddRounded />,
					},
					selected_open_costing: {
						name: "Selected Open Costing",
						key: "selected_open_costing",
						display: false,
						icon: <AddRounded />,
					},
					open_costing_dashboard: {
						name: "All Costings",
						key: "open_costing_dashboard",
						display: true,
						icon: <Dataset />,
					},
				},
			},
			production_allocation: {
				name: "Production Allocation",
				key: "production_allocation",
				display: true,
				icon: <AccountTree />,
			},
		},
	},
	po: {
		name: "PURCHASE ORDER",
		key: "po",
		display: false,
		icon: <Folder />,
		types: {
			fob_po: {
				name: "FOB  PO",
				key: "fob_po_po",
				display: false,
				icon: <DocumentScanner />,
			},
		},
	},
	studio: {
		name: "STUDIO",
		key: "studio",
		display: true,
		icon: <Camera />,
		types: {
			summary: {
				name: "Summary",
				key: "summary",
				display: true,
				icon: <AssessmentIcon />,
			},
			shoot_master: {
				name: "Master",
				key: "shoot_master",
				display: true,
				icon: <Dataset />,
				types: {
					shoot_attributes: {
						name: "Attributes",
						key: "shoot_attributes",
						display: true,
						icon: <Description />,
					},
					shoot_attr_groups: {
						name: "Attribute Groups",
						key: "shoot_attr_groups",
						display: true,
						icon: <Description />,
					},
				},
			},
			sample_inward: {
				name: "Studio Sample Inward",
				key: "sample_inward",
				display: true,
				icon: <Dataset />,
			},
			create_shoot: {
				name: "Create Shoot",
				key: "create_shoot",
				display: true,
				icon: <AddToPhotos />,
			},
			all_shoots: {
				name: "All Shoots",
				key: "all_shoots",
				display: true,
				icon: <AutoAwesomeMotion />,
			},
			shoot_archive: {
				name: "Shoot Archive",
				key: "shoot_archive",
				display: true,
				icon: <Archive />,
			},
			selected_shoot: {
				name: "Selected Shoot",
				key: "selected_shoot",
				display: false,
				icon: <Description />,
			},

			shoot_costing: {
				name: "Shoot Costing",
				key: "shoot_costing",
				display: true,
				icon: <CurrencyRupeeRounded />,
				types: {
					create_shoot_costing: {
						name: "Create Shoot Costing",
						key: "create_shoot_costing",
						display: true,
						icon: <AddRounded />,
					},
					all_shoot_costings: {
						name: "All Costings",
						key: "all_shoot_costings",
						display: true,
						icon: <DatasetRounded />,
					},
					selected_shoot_costing: {
						name: "Shoot Costing",
						key: "selected_shoot_costing",
						display: false,
						icon: <Description />,
					},
				},
			},
			modal_profiles: {
				name: "Model Profiles",
				key: "modal_profiles",
				display: true,
				icon: <RecentActors />,
				types: {
					modal_profile_master: {
						name: "Master",
						key: "modal_profile_master",
						display: true,
						icon: <Dataset />,
						types: {
							modal_attributes: {
								name: "Attributes",
								key: "modal_attributes",
								display: true,
								icon: <Description />,
							},
							modal_attr_groups: {
								name: "Attribute Groups",
								key: "modal_attr_groups",
								display: true,
								icon: <Description />,
							},
						},
					},
					create_modal_profile: {
						name: "Create Profile",
						key: "create_modal_profile",
						display: true,
						icon: <AddToPhotos />,
					},
					all_modal_profiles: {
						name: "All Profiles",
						key: "all_modal_profiles",
						display: true,
						icon: <AutoAwesomeMotion />,
					},
					selected_modal_profile: {
						name: "Selected Model Profile",
						key: "selected_modal_profile",
						display: false,
						icon: <Description />,
					},
				},
			},
		},
	},
	catalogue: {
		name: "CATALOGUE",
		key: "catalogue",
		display: true,
		icon: <Source />,
		types: {
			style_block_master: {
				name: "Style Block Master",
				key: "style_block_master",
				display: true,
				icon: <Dataset />,
			},
		},
	},
	// purchase_order: {
	// 	name: "Purchase Order",
	// 	key: "purchase_order",
	// 	display: true,
	// 	icon: <Folder />,
	// 	types: {
	// 		fob_po: {
	// 			name: "FOB PO",
	// 			key: "fob_po",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		fabric_po: {
	// 			name: "Fabric PO",
	// 			key: "fabric_po",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		trims_po: {
	// 			name: "Accessories PO",
	// 			key: "trims_po",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		job_work_po: {
	// 			name: "Job Work PO",
	// 			key: "job_work_po",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 	},
	// },
	// requisition: {
	// 	name: "Requisition",
	// 	key: "requisition",
	// 	display: true,
	// 	icon: <Folder />,
	// 	types: {
	// 		fabric_requisition: {
	// 			name: "Fabric Requisition",
	// 			key: "fabric_requisition",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		trims_requisition: {
	// 			name: "Accessories Requisition",
	// 			key: "trims_requisition",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 	},
	// },
	// grn: {
	// 	name: "GRN",
	// 	key: "grn",
	// 	display: true,
	// 	icon: <Folder />,
	// 	types: {
	// 		fabric_grn: {
	// 			name: "Fabric GRN",
	// 			key: "fabric_grn",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		trims_grn: {
	// 			name: "Accessories GRN",
	// 			key: "trims_grn",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 		fob_grn: {
	// 			name: "FOB GRN",
	// 			key: "fob_grn",
	// 			display: true,
	// 			icon: <Description />,
	// 		},
	// 	},
	// },
	users: {
		name: "USERS",
		key: "users",
		display: true,
		icon: <GroupAddRounded />,
	},
};

export const allBrands = {
	"RARE RABBIT": { name: "RARE RABBIT", key: "RARE RABBIT" },
	RAREISM: { name: "RAREISM", key: "RAREISM" },
	"RARE ONES": { name: "RARE ONES", key: "RARE ONES" },
	RAREZ: { name: "RAREZ", key: "RAREZ" },
};

export const dashboardParamName = "tab";
export const booleaStrOptions = {
	YES: { name: "Yes", key: "YES" },
	NO: { name: "No", key: "NO" },
};
export const inputTypes = {
	SELECT: { name: "Select", key: "SELECT" },
	MULTIPLE_SELECT: { name: "Multiple Select", key: "MULTIPLE_SELECT" },
	ENTER: { name: "Enter", key: "ENTER" },
	AUTO_GENERATE: { name: "Autogenerate", key: "AUTO_GENERATE" },
};
export const datatypes = {
	STRING: {
		name: "String",
		key: "STRING",
		htmlVar: "string",
		sqlVar: "varchar(255)",
		dependency: {
			input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key, inputTypes.SELECT.key],
		},
	},
	LONGTEXT: {
		name: "Long Text",
		key: "LONGTEXT",
		htmlVar: "string",
		sqlVar: "LONGTEXT",
		dependency: { input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key] },
	},
	NUMBER: {
		name: "Number",
		key: "NUMBER",
		htmlVar: "number",
		sqlVar: "integer",
		dependency: { input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key] },
	},
	DECIMAL: {
		name: "Decimal",
		key: "DECIMAL",
		htmlVar: "number",
		sqlVar: "float",
		dependency: { input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key] },
	},
	DATE: {
		name: "Date",
		key: "DATE",
		htmlVar: "date",
		sqlVar: "DATETIME",
		dependency: { input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key, inputTypes.AUTO_GENERATE.key] },
	},
	JSON: { name: "Json", key: "JSON", htmlVar: "file", sqlVar: "JSON", dependency: { input_type: [inputTypes.MULTIPLE_SELECT.key] } },
	BOOLEAN: {
		name: "Boolean",
		key: "BOOLEAN",
		htmlVar: "text",
		sqlVar: "BOOLEAN",
		dependency: { input_type: [inputTypes.SELECT.key, inputTypes.AUTO_GENERATE.key] },
	},
	FILE: {
		name: "File",
		key: "FILE",
		htmlVar: "file",
		sqlVar: "varchar(255)",
		dependency: { input_type: [inputTypes.ENTER.key, inputTypes.AUTO_GENERATE.key] },
	},
};
export const constraints = { notNull: "notNull", unique: "unique" };

export const statusOptions = {
	CREATED: { name: "Created", color: blue[300], key: "CREATED", icon: <EditNoteIcon fontSize="small" /> },
	NEW: { name: "New", color: blue[300], key: "NEW", icon: <DocumentScanner fontSize="small" /> },
	DRAFTED: { name: "Drafted", color: grey[300], key: "DRAFTED", icon: <DescriptionRounded fontSize="small" /> },
	APPROVED: { name: "Approved", color: lightGreen["A700"], key: "APPROVED", icon: <CheckCircleOutlineRounded fontSize="small" /> },
	PUBLISHED: {
		name: "Published",
		color: lightGreen["A700"],
		key: "PUBLISHED",
		icon: <CheckCircleOutlineRounded fontSize="small" />,
	},
	SOURCING_PENDING: {
		name: "Sourcing",
		color: yellow[600],
		key: "SOURCING_PENDING",
		icon: <Pending fontSize="small" />,
	},
	DESIGNER_PENDING: {
		name: "Designer",
		color: yellow[800],
		key: "DESIGNER_PENDING",
		icon: <Pending fontSize="small" />,
	},
	MRP_PENDING: {
		name: "MRP",
		color: yellow[700],
		key: "MRP_PENDING",
		icon: <Pending fontSize="small" />,
	},
	READY: {
		name: "Ready",
		color: blue[500],
		key: "READY",
		icon: <Pending fontSize="small" />,
	},
	RECEIVED: {
		name: "Received",
		color: lightGreen["A700"],
		key: "RECEIVED",
		icon: <CheckCircleOutlineRounded fontSize="small" />,
	},
	REJECTED: { name: "Rejected", color: red[600], key: "REJECTED", icon: <CancelOutlined fontSize="small" /> },
};
export const colorRejectBlockedStatuses = [
	statusOptions.REJECTED.key,
	statusOptions.CREATED.key,
	statusOptions.NEW.key,
	statusOptions.DRAFTED.key,
	statusOptions.DESIGNER_PENDING.key,
];
export const isRejectablePublishedColor = (row) => Boolean(row?.status) && !colorRejectBlockedStatuses.includes(row.status);
export const approvalOptions = {
	PENDING: { name: "Pending", color: blue[300], key: "PENDING", icon: <InfoIcon /> },

	APPROVED: { name: "Approved", color: lightGreen["A700"], key: "APPROVED", icon: <CheckCircleOutlineRounded /> },

	REJECTED: { name: "Rejected", color: red[600], key: "REJECTED", icon: <DangerousRounded /> },
};

export const publishColumns = {
	status: {
		name: "Status",
		key: "status",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
		[selectOptionsKeyName]: { type: arrType, list: Object.keys(statusOptions)?.map((row) => statusOptions[row]) },
	},
	published_by: {
		name: "Published By",
		key: "published_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	published_date: {
		name: "Published Date",
		key: "published_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 0,
		meta_data: true,
	},
};

export const createdByColumns = [
	{
		name: "Created By",
		key: "created_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Last Updated By",
		key: "last_updated_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
];
export const approvalColumns = [
	{
		name: "Approval",
		key: "is_approved",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.BOOLEAN.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Approved By",
		key: "approved_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Approved Date",
		key: "approved_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 0,
		meta_data: true,
	},
];
export const stageColumn = {
	name: "Stage",
	key: "stage",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
	meta_data: true,
};
export const styleImageColumn = {
	name: "Image",
	key: "url",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
	meta_data: true,
};
export const imageColumn = {
	name: "Image",
	key: "url",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
	meta_data: true,
};

export const styleFabricUpdationColumns = [
	{
		name: "Fabric Updated",
		key: "fabric_updated",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.BOOLEAN.key,
		sort_no: 0,
		meta_data: true,
	},
	{
		name: "Fabric Updated By",
		key: "fabric_updated_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
];

export const styleMrpUpdationColumns = [
	{
		name: "MRP Updated By",
		key: "mrp_updated_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		meta_data: true,
	},
];

export const datagridcolStyle = {
	headerAlign: "center",
	align: "center",
	flex: 1,
	minWidth: 90,
};

export const deleteTableColumn = (delFun, disableDelteFun = (row) => false) => {
	return {
		headerName: "DELETE",
		maxWidth: 100,

		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			let disable = disableDelteFun(row);
			if (!disable)
				return (
					<Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
						<IconButton variant="contained" color="error" onClick={() => delFun(row)}>
							<DeleteRounded />
						</IconButton>
					</Box>
				);
			else return <></>;
		},
	};
};
export const downloadTableColumn = (downloadFun) => {
	return {
		headerName: "Download",
		minWidth: 100,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			return (
				<Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
					<IconButton variant="contained" onClick={() => downloadFun(row)}>
						<DownloadRounded />
					</IconButton>
				</Box>
			);
		},
	};
};
export const imageTableColumn = (col) => {
	return {
		headerName: col?.name,
		field: col?.key,
		minWidth: 80,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
					<Box
						component="label"
						width="45px"
						height="55px"
						border={`1px solid ${grey[200]}`}
						display="flex"
						alignItems="center"
						justifyContent="center"
						overflow="hidden"
						position="relative">
						<img src={row?.[col?.key]} style={{ width: "100%", position: "absolute" }} alt="" />
					</Box>
				</Box>
			);
		},
	};
};
export const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

export const imageTableColumnWithEdit = (col, handleInputChange = () => {}) => {
	return {
		headerName: col?.name,
		field: col?.key,
		minWidth: 80,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex">
					<Box
						width="45px"
						height="55px"
						border={`1px solid ${grey[200]}`}
						// display="flex"
						overflow="hidden"
						position="relative">
						<img
							src={row?.[col?.key]}
							alt=""
							style={{
								width: "105%",
								position: "absolute",
								left: "50%",
								top: "50%",
								transform: `translate(-50%, -50%)`,
							}}
						/>
						<Box
							component="label"
							sx={{ position: "absolute", top: "18px", left: "18px", width: "30px", height: "30px" }}
							onClick={(e) => e.stopPropagation()}>
							<Edit fontSize="small" />
							<VisuallyHiddenInput onChange={(e) => handleInputChange(e, row)} type="file" multiple />
						</Box>
					</Box>
				</Box>
			);
		},
	};
};
export const stageTableColumn = (stageOptions) => {
	return {
		headerName: "Stage",
		field: "stage",
		minWidth: 120,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
					<Box
						display="flex"
						alignItems="center"
						height={"22px"}
						sx={{
							backgroundColor: stageOptions?.[row.stage]?.color || yellow[400],
							color: "white",
							padding: "4px 8px",
							borderRadius: "5px",
							"& .MuiSvgIcon-root": {
								fontSize: 16,
							},
						}}>
						{stageOptions?.[row.stage]?.icon}
						<Typography pl="3px" fontSize="12px" noWrap>
							{stageOptions?.[row.stage]?.name ? stageOptions?.[row.stage]?.name : "----"}
						</Typography>
					</Box>
				</Box>
			);
		},
	};
};
export const YesNoColumn = (stageOptions) => {
	return {
		headerName: "Stage",
		field: "stage",
		minWidth: 120,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
					<Box
						display="flex"
						alignItems="center"
						height={"22px"}
						// columnGap={1}
						sx={{
							backgroundColor: stageOptions?.[row.stage]?.color || yellow[400],
							color: "white",
							padding: "6px",
							borderRadius: "5px",
						}}>
						{stageOptions?.[row.stage]?.icon}{" "}
						<Typography pl="3px"> {stageOptions?.[row.stage]?.name ? stageOptions?.[row.stage]?.name : "----"}</Typography>
					</Box>
				</Box>
			);
		},
	};
};
export const tableMetadataDatagridRenderCells = {
	stage: {
		field: "stage",
		headerName: "Stage",
		width: 120,
		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
					<Box
						display="flex"
						alignItems="center"
						height={"22px"}
						// columnGap={1}
						sx={{
							backgroundColor: statusOptions[row.status]?.color || yellow[400],
							color: "white",
							padding: "6px",
							borderRadius: "5px",
						}}>
						{statusOptions[row.status]?.icon} <Typography pl="3px"> {statusOptions[row.status]?.name}</Typography>
					</Box>
				</Box>
			);
		},
		...datagridcolStyle,
	},
	is_approved: {
		field: "is_approved",
		headerName: "Approval",
		width: 120,
		renderCell: ({ row }) => {
			return (
				<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
					<Box
						display="flex"
						alignItems="center"
						height={"22px"}
						// columnGap={1}
						sx={{
							backgroundColor: approvalOptions[row.status]?.color || yellow[400],
							color: "white",
							padding: "6px",
							borderRadius: "5px",
						}}>
						{approvalOptions[row.status]?.icon} <Typography pl="3px"> {approvalOptions[row.status]?.name}</Typography>
					</Box>
				</Box>
			);
		},
		...datagridcolStyle,
	},
};

export const converAttrToDatagridCol = (attr) => {
	if (tableMetadataDatagridRenderCells?.[attr.key]) return tableMetadataDatagridRenderCells[attr.key];
	else {
		let obj = {
			field: attr?.key,
			headerName: attr?.name,
			...datagridcolStyle,
			valueGetter: (value, row) => {
				if (attr?.input_type === inputTypes.SELECT.key) {
					// return attr?.[selectOptionsKeyName]?.list?.find((option) => option.key === value)
					// 	?.name;
					return attr?.data_type === datatypes.BOOLEAN.key
						? value
							? booleaStrOptions.YES.name
							: booleaStrOptions.NO.name
						: value;
				} else if (attr?.input_type === inputTypes.MULTIPLE_SELECT.key) {
					return value?.length
						? value
								.map((val) => {
									// return 	attr?.[selectOptionsKeyName]?.list?.find(
									// 		(option) => option.key === val
									// 	)?.name
									return val;
								})
								.join(", ")
						: "";
				} else if (attr?.data_type === datatypes.DATE.key) {
					return value ? moment(value).format("DD/MM/YYYY") : "";
				} else {
					return value;
				}
			},
			editable: attr?.editable ? true : false,
		};
		if (attr?.editable && attr?.type) obj["type"] = attr?.type;
		if (attr?.headerClassName) obj["headerClassName"] = attr?.headerClassName;

		if (typeof attr.renderHeader === "function") {
			obj["renderHeader"] = ({ colDef }) => {
				return attr.renderHeader({ col: { ...colDef, ...attr } });
			};
		}
		if (typeof attr.renderCell === "function") {
			obj["renderCell"] = (params) => {
				return attr.renderCell(params);
			};
		}
		if (typeof attr.renderEditCell === "function") {
			obj["renderEditCell"] = (params) => {
				return attr.renderEditCell(params);
			};
		}

		return obj;
	}
};

export const muiCustomScrollbar = {
	"&::-webkit-scrollbar": {
		width: "0.45em",
	},
	"&::-webkit-scrollbar-track": {
		boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.08)",
		webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: grey[700],
		borderRadius: "4px",
		// outline: "1px solid slategrey",
	},
	"&::-webkit-scrollbar-thumb:hover": {
		backgroundColor: grey[800],
		// outline: "1px solid slategrey",
	},
};

export const getRelProtectedFileSignedUrl = async (filePath, expirySeconds) => {
	if (!filePath) throw new Error("No File Path Found");
	const body = { filePath };
	if (expirySeconds) body.expirySeconds = expirySeconds;
	const {
		data: { result },
	} = await axios.post("/api/designer/generate_style_file_url", body);

	return result.url;
};

export const CustomDatagridEditCell = ({ endAndrosment = "", ...params }) => {
	const { id, value, field, hasFocus } = params;
	const apiRef = useGridApiContext();

	const handleChange = (event) => {
		const newValue = event.target.value;
		apiRef.current.setEditCellValue({ id, field, value: newValue });
	};

	return (
		<TextField
			fullWidth
			variant="standard"
			value={value ?? ""}
			onChange={handleChange}
			autoFocus={hasFocus}
			InputProps={{
				// Use 'end' but wrap it in a Box to ensure it stays inside
				endAdornment: endAndrosment ? (
					<InputAdornment
						position="end"
						sx={{
							position: "absolute",
							right: 8,
							height: "100%",
							maxHeight: "none",
						}}>
						{endAndrosment}
					</InputAdornment>
				) : null,
				disableUnderline: true,
			}}
			sx={{
				width: "100%",
				height: "100%",
				display: "flex",
				"& .MuiInputBase-root": {
					height: "100%",
					fontSize: "inherit",
					pr: 4, // IMPORTANT: Add right padding so text doesn't overlap the %
					position: "relative", // Keeps the absolute adornment contained
				},
				"& .MuiInputBase-input": {
					padding: "0 8px", // Matches standard cell padding
					height: "100%",
					display: "flex",
					alignItems: "center",
				},
			}}
		/>
	);
};
